import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink, ActivatedRoute } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LoaderComponent } from 'src/app/shared/components/loader/loader.component';
import { LoaderService } from 'src/app/shared/services/loader/loader.service';
import { MatButtonModule } from '@angular/material/button';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTab, MatTabGroup, MatTabLabel } from '@angular/material/tabs';
import { PetitionsComponent } from 'src/app/shared/components/vacations/petitions/petitions.component';

@Component({
  selector: 'app-driversvactions',
  imports: [
    LoaderComponent,
    MatIconModule,
    RouterLink,
    MatButtonModule,
    MatSlideToggleModule,
    MatTabGroup,
    MatTab,
    MatTabLabel,
    PetitionsComponent,
  ],
  templateUrl: './driversvacations.component.html',
  styleUrls: [
    './driversvacations.component.css',
    '../../../shared/styles/layout.css',
  ],
})
export class DriversvacationsComponent implements OnInit, OnDestroy {
  year?: number;
  id?: number;
  reloadFlag: boolean = false;

  // Sync progress state
  private _snackBar = inject(MatSnackBar);

  constructor(
    private loaderService: LoaderService,
    private route: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    this.year = this.route.snapshot.params['year'];
    this.id = this.route.snapshot.params['id'];
    this.reloadData();
  }

  ngOnDestroy(): void {
  }

  reloadData(): void {

    this.reloadFlag = !this.reloadFlag;
  }

  openSnackBar(message: string): void {
    this._snackBar.open(message, 'Cerrar');
  }

  get isLoading(): boolean {
    return this.loaderService.getLoader();
  }

  onExportLoading(isLoading: boolean): void {
    if (isLoading) {
      this.loaderService.showLoader();
    } else {
      this.loaderService.hideLoader();
    }
  }

}
